import { withTheme } from 'theme';
import material3 from 'theme/material3';
import utils from 'utils';

const container = withTheme(() => ({
  width: '100%',
  cursor: 'pointer',
  color: material3.color.textPrimary,
  borderRadius: material3.shape.large,
  boxShadow: material3.elevation.level1,
  overflow: 'hidden',
  background: material3.color.surfaceContainerLowest,
  transition: 'box-shadow .18s ease, transform .18s ease',
  '&:hover': {
    boxShadow: material3.elevation.level2,
    transform: 'translateY(-1px)'
  }
}));

const imgWrapper = withTheme(() => ({
  ...utils.sx.flex.col('center', 'center'),
  width: '100%',
  position: 'relative',
  overflow: 'hidden',
  aspectRatio: '3/2',
}));

const header = withTheme((theme) => ({
  background: material3.color.surfaceContainerLow,
  width: '100%',
  padding: theme.spacing(1),
  borderRadius: `${material3.shape.large} ${material3.shape.large} 0 0`,
}));

const img = withTheme(() => ({
  width: '100%',
  borderRadius: `0 0 ${material3.shape.large} ${material3.shape.large}`,
  aspectRatio: '3/2'
}));

const name = withTheme(() => ({
  color: 'white',
  position: 'absolute',
  top: '16px',
  left: '16px'
}));

const styles = {
  container,
  header,
  img,
  imgWrapper,
  name
};

export default styles;
